import React from 'react'


export default function FilterComponent(props) {
  return (
    <h1>Filter Component</h1>
  )
};